import React from 'react';
import { range } from 'lodash';
import Skeleton from '@mui/material/Skeleton';
import { dayjsWithTimezone } from '../../../src/utils';
import { DEFAULT_TIMEZONE } from '../../../src/constants';

const FirstAvailabilityCalendarSkeleton = ({ timezonePractitioner }) => {
  const timezone = timezonePractitioner || DEFAULT_TIMEZONE;
  const dayjsTZ = dayjsWithTimezone(timezone);

  return (
    <div className="availability-calendar skeleton percy-hidden">
      {range(1, 6).map((k, i) => (
        <div className="availability-day" key={k}>
          <div className="availability-day__header pnl_availability_day">
            <span className="day">
              {`${dayjsTZ()
                .add(i, 'd')
                .format('ddd')}`}
            </span>
            <span className="date">
              {`${dayjsTZ()
                .add(i, 'd')
                .format('DD MMM')}`}
            </span>
          </div>
          <Skeleton
            className="availability-day__header skeleton "
            width={48}
            height={35}
          />
          <Skeleton
            className="availability-day__header skeleton "
            width={48}
            height={35}
          />
          <Skeleton
            className="availability-day__header skeleton "
            width={48}
            height={35}
          />
        </div>
      ))}
    </div>
  );
};

export default FirstAvailabilityCalendarSkeleton;
